/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.icon[_ngcontent-%COMP%]{height:64px;background-position-x:center}h3[_ngcontent-%COMP%]{font-weight:700}small[_ngcontent-%COMP%]{width:80%!important}.modal-footer[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}.icon.checked[_ngcontent-%COMP%]{background-image:url(ic_card_aprovada_blue.6a021b219b71dd9e7ec5.svg);background-repeat:no-repeat}"];
export { styles as styles };
